import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { getCurrentDomain } from '../config/domains';
import { CMSPageContent, getCMSPage } from '../services/api';

const Home: React.FC = () => {
  const domain = getCurrentDomain();
  const [content, setContent] = useState<CMSPageContent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getCMSPage('home').then((res) => {
      if (res.error) setError(res.error);
      else if (res.data) setContent(res.data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error loading content: {error}</div>;
  }

  const fields = content?.fields ?? {};
  const features = content?.blocks?.features ?? [];

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title" style={{ color: domain.primaryColor }}>
          {fields.hero_title || domain.fullName}
        </h1>
        {fields.hero_tagline && (
          <h2 className="page-subtitle">{fields.hero_tagline}</h2>
        )}
      </div>

      <div className="page-content">
        {fields.intro_text && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(fields.intro_text) }} />}

        {fields.hero_cta_text && fields.hero_cta_url && (
          <p>
            <a
              href={fields.hero_cta_url}
              className="btn"
              style={{ backgroundColor: domain.primaryColor, color: 'white', textDecoration: 'none', padding: '0.5rem 1.25rem', borderRadius: '4px' }}
            >
              {fields.hero_cta_text}
            </a>
          </p>
        )}

        {features.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem', marginTop: '2rem' }}>
            {features.map((block) => (
              <div key={block.id} style={{ padding: '1.25rem', border: '1px solid #eee', borderRadius: '6px', backgroundColor: '#fafafa' }}>
                <h3 style={{ color: domain.primaryColor, marginTop: 0 }}>{block.fields.title}</h3>
                {block.fields.body && <div style={{ margin: 0, color: '#555' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.fields.body) }} />}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
